import { Component, OnInit, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('popOverState', [
      state('show', style({
        opacity: 1
      })),
      state('hide', style({
        opacity: 0
      })),
      transition('show => hide', animate('300ms ease-out')),
      transition('hide => show', animate('800ms ease-in'))
    ]),
    trigger('hoveredState', [
      state('notHovered', style({
        transform: 'translateX(0)'
      })),
      state('hovered', style({
        transform: 'translateX(-20px)'
      })),
      transition('notHovered => hovered', animate('300ms')),
      transition('hovered => notHovered', animate('100ms'))
    ])
  ]
})
export class HomeComponent implements OnInit {

  rowHeight: string = "15vw";
  margin = "0px";
  opened = 0;
  show: boolean = false;
  state: string = "notHovered";

  public scrollEvent: any;

  images = [
    '../../../assets/images/sponsors/sponsors1.jpg',
    '../../../assets/images/sponsors/sponsors2.jpg',
    '../../../assets/images/sponsors/sponsors3.jpg',
    '../../../assets/images/sponsors/sponsors4.jpg'
  ];

  constructor(
    private router: Router,
    private title: Title,
    private meta: Meta) {
    this.title.setTitle("Home");
    this.meta.addTag({ name: 'description', content: "Vind hier alle informatie over de 34ste editie van de tongelse dorpsfeesten." });
    this.meta.addTag({ name: 'keywords', content: "Tongels dorpsfeest, tongelse dorpsfeesten, feest tongerlo, dorpsfeesten tongerlo" })

    let width = window.innerWidth;
    if (width <= 500) {
      this.rowHeight = "30vw";
    }
  }

  ngOnInit() { }

  onHovered() {
    this.state == "notHovered" ? this.state = "hovered" : this.state = "notHovered";
  }

  onExpand1() {
    this.opened = 1;
    let card = document.getElementById('image');
    let height = card.scrollHeight;
    this.margin = (height * 6 + 450) + "px";
  }

  onExpand2() {
    this.opened = 2;
    let card = document.getElementById('image');
    let height = card.scrollHeight;
    if (height < 400) {
      height += ((600 - height) / 10);
    }
    this.margin = (height * 15 + 1150) + "px";
  }

  onExpand3() {
    this.opened = 3;
    let card = document.getElementById('image');
    let height = card.scrollHeight;
    if (height < 400) {
      height += ((400 - height) / 4);
    }
    this.margin = (height * 9 + 550) + "px";
  }

  onClosed1() {
    if (this.opened == 1) {
      this.margin = "0px";
      this.opened = 0;
    }
  }

  onClosed2() {
    if (this.opened == 2) {
      this.margin = "0px";
      this.opened = 0;
    }
  }

  onClosed3() {
    if (this.opened == 3) {
      this.margin = "0px";
      this.opened = 0;
    }
  }

  stateName(): string {
    return this.show ? 'show' : 'hide';
  }

  toggle() {
    this.show = !this.show;
  }

  navigateToPictures() {
    this.router.navigate(['images']);
  }

  navigateToInfo() {
    this.router.navigate(['info']);
  }

  navigateToCovid() {
    this.router.navigate(['covid']);
  }

  
  @HostListener('scroll')
  public asd(): void {
  console.log('scrolling');
}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let width = event.target.innerWidth;
    if (width <= 500) {
      this.rowHeight = "30vw";
    } else {
      this.rowHeight = "15vw";
    }

    switch (this.opened) {
      case 0:
        break;
      case 1:
        let height1 = window.innerWidth / 4 + 400;
        this.margin = height1 + "px";
        break;
      case 2:
        let card1 = document.getElementById('image');
        let height2 = card1.scrollHeight;
        if (height2 < 400) {
          height2 += ((400 - height2) / 10);
        }
        this.margin = (height2 * 9 + 900) + "px";
        break;
      case 3:
        let card2 = document.getElementById('image');
        let height3 = card2.scrollHeight;
        if (height3 < 400) {
          height3 += ((400 - height3) / 10);
        }
        this.margin = (height3 * 10 + 800) + "px";
        break;

    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: "smooth" });
  }

}
